import {
  ChangeDetectorRef,
  Component,
  OnInit,
  OnDestroy,
  ViewEncapsulation,
  Input,
  Output,
  EventEmitter,
  Inject,
} from '@angular/core'
import { SideBoardService } from './side-board.service'
import { ISideboard, ISideboardActions, Sideboardctions } from './ISideboard'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { AgenticModeService } from '@app/agentic-assistant/services/agentic-mode.service'

@Component({
  selector: 'phdsoft-sideboard',
  templateUrl: './side-board.component.html',
  styleUrls: ['./side-board.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class SideBoardComponent implements OnInit, OnDestroy {
  isVisible = true
  isMinimized = false

  @Input() options: ISideboard
  @Input() loading = false
  @Input() okDisabled: boolean

  get okButtonDisabled(): boolean {
    return this.okDisabled
  }

  get okAllButtonDisabled(): boolean {
    return this.okDisabled
  }

  @Output() cancel: EventEmitter<ISideboardActions> = new EventEmitter<ISideboardActions>()
  @Output() visibilityChange = new EventEmitter<boolean>()
  @Output() ok: EventEmitter<ISideboardActions> = new EventEmitter<ISideboardActions>()
  @Output() okAll: EventEmitter<ISideboardActions> = new EventEmitter<ISideboardActions>()
  @Output() MaximizedMobile: EventEmitter<ISideboardActions> = new EventEmitter<ISideboardActions>()
  @Output() maximizeChange = new EventEmitter<boolean>()

  constructor(
    public sideBoardService: SideBoardService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private agenticModeService: AgenticModeService,
    private cd: ChangeDetectorRef,
  ) {
    this.visibilityChange.emit(this.isVisible)
  }

  ngOnInit(): void {
    // Check if we should open minimized (either explicitly set or in agentic mode)
    const shouldMinimize = this.options?.isMinimized || this.agenticModeService.currentMode === 'agents'
    
    if (shouldMinimize) {
      if (this.options) {
        this.options.isMinimized = true
      } else {
        this.options = { VisibleMini: true, VisibleClose: true, isMinimized: true }
      }
      this.setMinimized(true)
    }
    
    this.sideBoardService.register(this)
    
    if (shouldMinimize) {
      this.minimizeWindow()
    }
  }

  ngOnDestroy(): void {
    this.sideBoardService.unregister(this)
  }

  // isMinimized is toggled from outside this component's subtree (minimized-tabs
  // dock, SideBoardService), so OnPush hosts are not marked dirty by the event
  // itself — markForCheck() here keeps them in sync.
  public setMinimized(value: boolean): void {
    this.isMinimized = value
    this.cd.markForCheck()
  }

  minimizeWindow(): void {
    this.setMinimized(true)
    this.sideBoardService.minimizeInstance(this)
    this.visibilityChange.emit(false)
  }

  // onResize() {
  //   //TODO
  // }

  onOk() {
    this.ok.emit({ Action: Sideboardctions.Ok, Event: this.data })
  }

  onOkAll() {
    this.okAll.emit({ Action: Sideboardctions.OkAll, Event: this.data })
  }

  onClose(): void {
    this.cancel.emit({ Action: Sideboardctions.Close })
  }

  public restore(): void {
    this.setMinimized(false)
    this.sideBoardService.activateInstance(this)
    this.visibilityChange.emit(true)
  }

  toggleMaximize(): void {
    this.options.isMaximized = !this.options.isMaximized
    this.maximizeChange.emit(this.options.isMaximized)
    this.sideBoardService.setMaximized(this.options.isMaximized)
  }
}
